import { createShader } from "shaders/js";
import { gsap } from "gsap";

export default async function expertiseShader() {
  const expertise_canvas = document.getElementById("expertise-shader");
  const shader = await createShader(expertise_canvas, {
    components: [
      {
        type: "SolidColor",
        id: "idmocyrp51rutd7nssn",
        props: {
          color: "#0C172B",
        },
      },
      {
        type: "Aurora",
        id: "idmocy8sqbd4fs6n0li",
        props: {
          balance: 100,
          colorA: "#008f8f",
          colorB: "#008f8f",
          colorC: "#0071a8",
          height: {
            type: "map",
            source: "",
            channel: "alpha",
            inputMin: 0,
            inputMax: 1,
            outputMin: 10,
            outputMax: 100,
          },
          rayDensity: {
            type: "map",
            source: "idmocyrp51rutd7nssn",
            channel: "alpha",
            inputMax: 1,
            inputMin: 0,
            outputMax: 100,
            outputMin: 0,
            curve: 0.2,
          },
          speed: 10,
          transform: {
            rotation: 180,
          },
          waviness: {
            mode: "loop",
            type: "auto-animate",
            speed: 5,
            outputMax: 0,
            outputMin: 0,
          },
        },
      },
      {
        type: "Liquify",
        id: "idmocygnamhce056hb6",
        props: {
          intensity: 20,
          stiffness: 30,
          visible: true,
        },
      },
      {
        type: "Glitch",
        id: "idmohlrxehmb6r1sv4r",
        props: {
          intensity: 0.56,
          speed: 3.5,
          visible: false,
        },
      },
    ],
  });

  let exp_shader_timeout = null;

  window.addEventListener("resize", function (e) {
    clearTimeout(exp_shader_timeout);
    exp_shader_timeout = setTimeout(function () {
      gsap.set(expertise_canvas, {
        width: document.querySelector(".expertise-grid").offsetWidth,
        height: document.querySelector(".expertise-grid").offsetHeight,
      });
      shader.resize();
    }, 250);
  });
}
